import styles from "./Contact.module.css"
import phoneIcon from "../../images/phoneIcon.png"
import mailIcon from "../../images/mailIcon.png"
import locationIcon from "../../images/locationIcon.png"
import Location from "../../components/Location"
import emailjs from '@emailjs/browser';
import { useEffect, useRef, useState } from "react"

import AOS from "aos"
import "aos/dist/aos.css";
export default function Contact() {
    const [status, setStatus] = useState(false)
    useEffect(() => {
        AOS.init({ duration: 2000 })
    }, [])

    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();


        emailjs.sendForm(process.env.REACT_APP_YOUR_SERVICE_ID, process.env.REACT_APP_YOUR_TEMPLATE_ID, form.current, process.env.REACT_APP_YOUR_PUBLIC_KEY)
            .then((result) => {
                console.log(result.text);
                console.log("Message Sent Successfully!")
                e.target.reset()
                setStatus(true)
                setTimeout(() => {
                    setStatus(false);
                }, 3000);
            }, (error) => {
                console.log(error.text);
            });

    };




    return (
        <div>

            <div className={styles.mainContact} data-aos="fade-up" >
                <p className={styles.contactHead}>CONTACT</p>
                <p className={styles.contactSubHead}>If you have any queries, feel free to message here or connect with me directly via phone call.</p>
                <div className={styles.contactBox} data-aos="fade-up">
                    <div className={styles.contactCol1}>
                        <p className={styles.contactHead2}>Contact Details</p>
                        <p className={styles.contactDesc}>Fill the adjacent form.Describe your query briefly. You will reveive a reply within 24 hours.</p>
                        <div className={styles.contactDetails}>
                            <div className={styles.contact1}>  <img src={phoneIcon} className={styles.icon1}></img><p>+91 9246178292</p></div>
                            <div className={styles.contact1}>  <img src={mailIcon} className={styles.icon1}></img><p>shaikhah.advocate@gmail.com</p></div>
                            <div className={styles.contact1}>  <img src={locationIcon} className={styles.icon1}></img><p>16-2-741/B/50/A/12, Ground Floor,
                                Asmangadh, Besides st. Joseph
                                School, Malakpet,
                                Hyderabad,
                                500036 (TS).</p></div>

                        </div>

                    </div>
                    <form ref={form} onSubmit={sendEmail} className={styles.contactCol2}>
                        <div className={styles.subCol2}>
                            <input type="text" placeholder="your name" name="user_name"></input>

                            <input type="email" placeholder="email" name="user_email"></input>
                            <input type="text" placeholder="phone no" name="user_phone"></input>
                        </div>
                        <div className={styles.subdiv2}>  <input className={styles.ContactSubject} type="text" placeholder="subject" name="subject"></input>
                            <textarea placeholder="Describe your query in short here..." name="message"></textarea></div>
                        <div className={styles.btnDiv}>
                            <button type="submit" value="send" className={styles.SubmitBtn}>Send</button>
                        </div>
                    </form>
             
                </div>
                {status && <h2 style={{textAlign:"center",color:"white"}}>Submitted successfully!</h2>}
            </div>
            <div data-aos="fade-up" >
                <Location />
            </div>
        </div>
    )
}